import type { ConceptDef } from '../types';
import { PLACES } from '../../games/scenes/places';

export const FIND_IN_PICTURE: ConceptDef[] = PLACES.map((p) => ({
  kind: 'findInScene',
  id: `spy-${p.id}`,
  label: `Find It in the Picture: ${p.label}`,
  category: 'Receptive',
  description: `A picture of a ${p.label.toLowerCase()}. Hear “find the …” and touch it.`,
  config: { scene: p.id, parts: p.parts.slice(0, 6).map((x) => x.id), promptMode: 'AUDIO', errorless: 'off' },
}));
